import { Fee } from "./order/api-models/order-pd-response.model";
import { AdditionalOfferData } from "./order/workflow/additional-offer.model";
import { DeviceShippingOption } from "./ShippingOption";

export interface LineConfigurationItem {
    lineNumber: number;
    fee?: LineItemFee;
    disclosure?: string;
    [key: string]: any;
}

export interface LineItemFee extends Fee {
}

export interface UpgradeDeviceConfigurationItem extends LineConfigurationItem {
    preUpgradeProcessCompleted: boolean;
    upgradeType: string;
    transactionType: 'existing' | 'upgrade';
}

export enum LineDeviceType {
    NEW = 'NEW',
    ONHAND = 'ONHAND',
    BYOD = 'BYOD'
}

export interface DeviceConfigurationItem extends LineConfigurationItem {
    deviceType: LineDeviceType;
    confirmDeviceSIM: string | null;
    deviceIMEI: string | null;
    existingIMEI: string | null;
    deviceSIM: string | null;
    inStockDevice: any | null;
    shipSIM: string | null;
    simIccid: string | null;
    tradeInPromotion: any | null;
    shippingOption: DeviceShippingOption; // Bestbuy only
    selectedDevice: {
        Description: string;
        DeviceAccessCodeFee: number;
        Upc: number;
        DeviceColor: string;
        DeviceHexColor: string;
        DeviceMemoryGB: string;
        DeviceModel: string;
        DevicePromotionAvailable: string;
        DeviceType: string;
        DeviceTypeSimple: string;
        Name: string;
        Fee: LineItemFee;
        OnHandSKU: string;
        ChoiceCode: string;
        Image?: string | null;
    }
    transactionType: string | null;
    upgradeProcessInitiated?: boolean;
    cartDiscloure?: string;
    byodDeviceDetails?: BYODDeviceDetailResponse;
    lineValidationState?: 'failure' | 'success' | 'error' | null;
}

export interface ProtectionPlanConfigurationItem extends LineConfigurationItem {
    planName: string;
    planSelected: string;
    fee: LineItemFee;
}

export interface WirelessPlanConfigurationItem extends ProtectionPlanConfigurationItem {
    disclosureChecked: boolean;
}

export interface InstallmentPlanConfigurationItem extends LineConfigurationItem {
    Usoc: string;
    downPayment: any | null;
    downPaymentAmount: any | null;
    planName: string;
    planSelected: string;
    isTodaysCharge: boolean;
    optionalDownPaymentAmount?: number;
    hasOptionalDownPayment?: boolean;
    requiredDownPaymentAmount?: number;
    hasRequiredDownPayment?: boolean;
    additionalInstallments?: Array<{ label: string, value: number }>;
}

export interface PhoneNumberConfigurationItem extends LineConfigurationItem {
    accountName: string | null;
    accountNumber: string | null;
    numberType: string;
    pinNumber: string | null;
    portNumber: string | null;
    transactionNumber: string;
}

export interface TradeInQuestionState {
    questionCode: string;
    answer: string | null;
    text?: string;
    validAnswers?: string[];
}

export interface PromotionConfigurationItem extends LineConfigurationItem {
    type: 'standard' | 'premiumTradeIn' | 'ndsChoice';
    promotionCode: string;
    customizationCode: string;
    customizationType?: string;
    isAccepted: boolean;
    name?: string;
    tradeInDevice?: any | null;
    tradeInValue?: string | null;
    useAdvancedFlow?: boolean;
    acceptChoiceCode?: string;
    declineChoiceCode?: string;
    promoType?: string;
    description?: string;
    tradeInQuestions?: TradeInQuestionState[];
    deviceDetails?: any | null;        // the viTradeInSubmit result
    imeiMode?: boolean;
    imeiNumber?: string;
    imeiError?: string;
    tradeInDevicesSnapshot?: any[];    // the device list at save time, restored on rehydrate
}

export interface WirelessLineMetadata extends LineConfigurationItem {
}

export interface SingleLineConfiguration {
    upgradeDevice?: UpgradeDeviceConfigurationItem;
    device?: DeviceConfigurationItem;
    protectionPlan?: ProtectionPlanConfigurationItem;
    installmentPlan?: InstallmentPlanConfigurationItem;
    phoneNumber?: PhoneNumberConfigurationItem;
    promotions?: PromotionConfigurationItem[];
    wirelessPlan?: WirelessPlanConfigurationItem;
    metaData?: WirelessLineMetadata;
    offers?: WirelessLineOfferConfiguration;
    lic?: LicLineSource;
}

// The LIC launch line a line was built from; absent for account and agent-added lines
export interface LicLineSource extends LineConfigurationItem {
    licLineNumber: number;
    pendingUpgrade?: boolean;
}

export interface WirelessLineOfferConfiguration extends LineConfigurationItem {
    offers: AdditionalOfferData[];
}

export interface LineConfigurationState {
    [lineKey: string]: SingleLineConfiguration; // line1, line2, line3, etc.
}

export interface BYODDeviceDetailResponse {
    Type: 'WIRELESS';
    Code: number;
    Message: string;
    SubType: 'ValidateBYOD' | string;
    Result: 'Approved' | string;
    Manufacturer: string;
    Model: string;
    DeviceSku: string;
    DeviceType: string;
    ImeiType: string;
    IsUnlocked: 'True' | 'False';
    ESIMEligible: 'True' | 'False';
    ESIMRequired: 'True' | 'False';
    ESIMICCID: string;
    ESIMReason: string;
    DenialReason: string | null;
}